// @flow

import React from "react";
import { SchemaForm } from "@components";
import uiSchema from "./__ui__/schema";
import type { AllergyItem } from "@modules/employee/reducer/medical-details/types";

type OwnProps = $Exact<{
  data: AllergyItem | null,
  schema: Object | null,
  onSubmit: (data: AllergyItem) => void,
}>;

type Props = OwnProps;

export class AllergyForm extends React.Component<Props> {
  form: *;

  render() {
    return (
      <SchemaForm
        ref={this.form}
        className="w-100"
        formData={this.props.data || {}}
        schema={this.props.schema || {}}
        onSubmit={this.props.onSubmit}
        uiSchema={uiSchema}
        externalSubmit
      />
    );
  }
}

export default AllergyForm;
